import { Form, Input } from "antd";
import React from "react";
import PropTypes from "prop-types";

const TextInput = ({
  rules = [],
  label,
  name,
  onChange,
  inputProps,
  hasFeedback = false,
}) => {
  const [isRequired, setIsRequired] = React.useState(false);

  React.useEffect(() => {
    if (rules && rules.length && !isRequired) {
      setIsRequired(rules.find((item) => item.required === true));
    }
  }, [rules, isRequired]);

  const handlerChange = (value) => {
    onChange && onChange(value);
  };

  return (
    <Form.Item
      key={name}
      label={<span style={{ textTransform: "capitalize" }}>{label}</span>}
      hasFeedback={hasFeedback}
      required={isRequired}
      name={name}
      rules={rules}
    >
      <Input onChange={handlerChange} placeholder={label} {...inputProps} />
    </Form.Item>
  );
};

TextInput.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.any),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  inputProps: PropTypes.any,
  hasFeedback: PropTypes.any,
};

export default TextInput;
